import { render, staticRenderFns } from "./DocShare.vue?vue&type=template&id=03292c1b&scoped=true&"
import script from "./DocShare.vue?vue&type=script&lang=js&"
export * from "./DocShare.vue?vue&type=script&lang=js&"
import style0 from "./DocShare.vue?vue&type=style&index=0&id=03292c1b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03292c1b",
  null
  
)

export default component.exports